<template>
  <div id="qualification">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends资格管理</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="searchBtn"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-circle-plus-outline"
          @click="(createVisible = true), (createFormData = {})"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="el-icon-edit-outline"
          @click="openEditShow()"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-delete"
          @click="deleteUser()"
          >删除</el-button
        >
        <!-- <el-button
          v-if="jurisdiction.import"
          icon="iconfont icon-chakan1"
          @click="importDialog = true"
          >导入</el-button
        > -->
      </div>
    </div>
    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          :inline="true"
          label-width="150px"
          :model="searchForm"
          size="small"
        >
          <el-form-item label="申请人姓名\手机号">
            <el-input v-model="searchForm.search"></el-input>
          </el-form-item>
          <el-form-item label="公司">
            <el-input v-model="searchForm.company"></el-input>
          </el-form-item>

          <el-form-item label="创建日期从">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 创建弹窗 -->
    <div class="create">
      <el-dialog
        :close-on-click-modal="false"
        width="326px"
        title="GIADA Friends资格管理-创建"
        :visible.sync="createVisible"
      >
        <div style="padding-top: 30px">
          <el-form
            size="mini"
            :label-position="labelPosition2"
            :model="createFormData"
            :rules="createdRules"
            ref="createRef"
            label-width="80px"
          >
            <el-form-item label="申请人姓" prop="lastName">
              <el-input v-model="createFormData.lastName"></el-input>
            </el-form-item>
            <el-form-item label="申请人名" prop="firstName">
              <el-input v-model="createFormData.firstName"></el-input>
            </el-form-item>
            <el-form-item label="移动电话" prop="mobile">
              <el-input
                v-model="createFormData.mobile"
                minlength="11"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="company">
              <el-input v-model="createFormData.company"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="createFormData.position"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="createdTable">保 存</el-button>
          <el-button @click="createVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="revise">
      <el-dialog
        :close-on-click-modal="false"
        width="326px"
        title="GIADA Friends资格管理-修改"
        :visible.sync="reviseVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition2"
          :model="modifyForm"
          :rules="createdRules"
          ref="createRef"
          label-width="80px"
          style="margin-top: 30px"
        >
          <el-form-item label="申请人姓" prop="lastName">
            <el-input v-model="modifyForm.lastName"></el-input>
          </el-form-item>
          <el-form-item label="申请人名" prop="firstName">
            <el-input v-model="modifyForm.firstName"></el-input>
          </el-form-item>
          <el-form-item label="移动电话" prop="mobile">
            <el-input
              v-model="modifyForm.mobile"
              maxlength="11"
              pattern="^1[3456789]\d{9}$"
              required
              placeholder="请输入11位手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input v-model="modifyForm.company"></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input v-model="modifyForm.position"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifySaveChange">保 存</el-button>
          <el-button
            @click="(reviseVisible = false), (templatei = {}), (radioxz = '')"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="删除GIADA Friends资格管理确认取消对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">删除</span>GIADA Friends资格管理信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="removedBtn">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导入弹窗 -->
    <!-- <div class="importBox">
      <el-dialog
        :close-on-click-modal="false"
        width="30%"
        title="GIADA Friends资格管理—导入"
        :visible.sync="importDialog"
      >
        <el-form>
          <el-form-item label="选择待导入GIADA Friends资格管理的申请人员文件">
            <el-input v-model="value" size="min"></el-input>
            <el-button>下载模板</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div> -->
    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <el-table
          height="530px"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="loading"
          v-el-table-infinite-scroll="load"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column label width="30">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radioxz"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column label="申请人姓名">
            <template slot-scope="scope"
              >{{ scope.row.lastName }}{{ scope.row.firstName }}</template
            >
          </el-table-column>
          <el-table-column prop="mobile" label="移动电话"></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="position" label="职位"></el-table-column>
          <el-table-column
            prop="gfcode"
            label="对应GIADA Friends编号"
          ></el-table-column>
          <el-table-column
            prop="createUserName"
            label="创建人"
          ></el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <div v-if="scope.row.createTime !== null">
                {{ scope.row.createTime | dateFormat }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            label="最后修改人"
          ></el-table-column>
          <el-table-column prop="updateTime" label="最后修改时间">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" align="center" min-width="100">
            <template slot-scope="scope">
              <div class="table-button">
                <el-button
                  size="mini"
                  title="修改"
                  icon="iconfont icon-xiugai1"
                  @click="openEditShow(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="删除"
                  icon="iconfont icon-a-shanchu11"
                  @click="deleteUser(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <el-alert
          v-if="total <= tableData.length"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        ></el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import {
  standardQueryApi,
  standardSearchApi,
  standardDeleteApi,
  standardInsertApi,
  standardUpdate,
} from "@/api/friends";
export default {
  name: "centre",
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      deleteFormVisible: false,
      // 创建弹窗
      createVisible: false,
      // 修改弹窗
      reviseVisible: false,
      labelPosition: "right",
      labelPosition2: "left",
      // importDialog: false, //导入弹窗
      // 创建
      createFormData: {
        cpyNO: getcpyNo,
        firstName: "",
        lastName: "",
        mobile: "",
        company: "",
        position: "",
      },
      // 修改
      modifyForm: {
        firstName: "",
        lastName: "",
        mobile: Number,
        company: "",
        position: "",
      },
      searchForm: {
        pageNo: 1,
        pageSize: 50,
        search: "",
        company: "", //公司
        startDay: "",
        endDay: "",
      },
      dateValue: [],
      // ----
      queryInfo: {
        cpyNO: getcpyNo(),
        pageNo: 1,
        pageSize: 50,
      },
      tableData: [],
      total: 0,
      size: 0,
      pageNum: 1,
      pageSize: 0,
      deleteID: null,
      // 创建form验证规则
      createdRules: {
        firstName: [
          { required: true, message: "请输入填写内容", trigger: "blur" },
        ],
        lastName: [{ required: true, message: "请填写内容", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的手机号", trigger: "blur" },
        ],
        cpyNO: [{ required: true, message: "请填写内容", trigger: "blur" }],
        position: [{ required: true, message: "请填写内容", trigger: "blur" }],
      },
      // /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/
      radioxz: "",
      value: "",
      templatei: {},
      bodyStyle: {
        padding: "0px",
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        // import: false,
        delete: false,
      },
      loading: false,
    };
  },
  created() {
    // this.loading = true;
    this.tableList();
    let Qualification = JSON.parse(localStorage.getItem("Qualification"));
    console.log(Qualification);
    for (let i = 0; i < Qualification.length; i++) {
      if (Qualification[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Qualification[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Qualification[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      // if (Qualification[i].menuName == "导入") {
      //   this.jurisdiction.import = true;
      //   continue;
      // }
      if (Qualification[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
    }
  },
  computed: {
    onLoading() {
      console.log(this.total, this.tableData.length);
      return this.loading || this.total < this.tableData.length;
    },
  },
  methods: {
    // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
    getCurrentRow(row) {
      this.templatei = row;
      console.log(this.templatei);
    },

    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //表格数据
    async tableList() {
      this.loading = true;
      await standardQueryApi(this.queryInfo).then((res) => {
        if (this.queryInfo.pageNo == 1) this.tableData = [];
        this.tableData = this.tableData.concat(res.data.list);
        this.total = res.data.total;
        this.size = res.data.size;
        this.loading = false;
        this.pageSize = res.data.pageSize;
      });
    },

    async searchBtn() {
      this.tableData = [];
      if (this.dateValue && this.dateValue.length > 0) {
        this.searchForm.startDay = this.renderTime(this.dateValue[0]).substring(
          0,
          10
        );
        this.searchForm.endDay = this.renderTime(this.dateValue[1]).substring(
          0,
          10
        );
      } else {
        this.searchForm.startDay = "";
        this.searchForm.endDay = "";
      }

      await standardSearchApi(this.searchForm).then((res) => {
        if (res.success == true) {
          this.tableData = [];
          this.tableData = res.data.list;
          this.loading = false;
        }
      });
    },
    load() {
      if (this.total < this.tableData.length) {
        setTimeout(() => {
          if (this.total > this.tableData.length) {
            this.queryInfo.pageNo += 1;
            this.tableList();
          }
        }, 1000);
      }
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 时间事件
    dataChange(value) {
      this.searchForm.startDay = value[0];
      this.searchForm.endDay = value[1];
    },
    //打开修改弹窗
    deleteUser(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.id) {
        this.deleteFormVisible = true;
        this.deleteID = this.templatei.id;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //单行数据删除
    removedBtn() {
      standardDeleteApi({
        ID: this.deleteID,
      }).then((res) => {
        if (res.success == true) {
          (this.templatei = {}), (this.radioxz = "");
          this.deleteFormVisible = false;
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
          this.$message.success("删除成功!");
        } else {
          return this.$message.error("删除失败!");
        }
      });
    },
    //创建
    createdTable() {
      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          await standardInsertApi(this.createFormData).then((res) => {
            if (res.success == true) {
              this.$message.success("创建成功!");
              this.createVisible = false;
              this.tableData = [];
              this.queryInfo.pageNo = 1;
              this.tableList();
            } else {
              this.$message.error("你的操作很骚呀!");
            }
          });
        }
      });
    },
    // 手机号验证规则

    // 修改
    openEditShow(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.id) {
        this.reviseVisible = true;
        // this.modifyForm = this.templatei;
        this.modifyForm = {
          lastName: this.templatei.lastName,
          firstName: this.templatei.firstName,
          mobile: this.templatei.mobile,
          company: this.templatei.company,
          position: this.templatei.position,
          id: this.templatei.id,
        };
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    async modifySaveChange() {
      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          await await standardUpdate({
            cpyNO: getcpyNo(),
            ID: this.modifyForm.id,
            firstName: this.modifyForm.firstName,
            lastName: this.modifyForm.lastName,
            mobile: this.modifyForm.mobile,
            position: this.modifyForm.position,
            company: this.modifyForm.company,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("修改成功!");
              this.reviseVisible = false;
              this.templatei = {};
              this.radioxz = "";
              this.queryInfo.pageNo = 1;
              this.tableData = [];
              this.tableList();
            } else {
              return this.$message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#qualification {
  // height: 1350px;
  height: 100%;
}
.header {
  .header-text {
    width: 22rem;
    height: 50px;
    // margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 创建弹窗样式
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 修改弹窗样式
  .revise {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .importBox {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
}
</style>
